import { render, staticRenderFns } from "./ConnectionsList.vue?vue&type=template&id=37a746af&"
import script from "./ConnectionsList.vue?vue&type=script&lang=ts&"
export * from "./ConnectionsList.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionsList.vue?vue&type=style&index=0&id=37a746af&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports